import { useState } from "react";

import useTargetingMutations from "../../../../../datahooks/useTargetingMutations";
import SectionHeading from "../../../SectionHeading";
import Stepper from "../../Stepper";
import StepperNextButton from "../../StepperNextButton";
import CrmLeads from "./CrmLeads";
import CrmSources from "./CrmSources";

import type { CsvState } from "../../../../../types";

export default function Crm() {
  const [csvState, setCsvState] = useState<CsvState>(null);
  const [selectSource, setSelectSource] = useState<{
    id: string;
    name: string;
    urlVariable?: string;
  }>();

  const { setTargeting, isSettingTargeting } = useTargetingMutations();

  const { parsed, mainIdentifier, columns } = csvState ?? {};

  const isFileError =
    !csvState ||
    !mainIdentifier ||
    !parsed.length ||
    !columns.every((col) => !!col);

  function onNext() {
    setTargeting({
      campaignTargeting: {
        profiles: parsed,
        url_column: mainIdentifier,
      },
    });
  }

  function onBack() {
    setSelectSource(null);
    setCsvState(null);
  }

  return (
    <>
      <SectionHeading
        title="CRM targeting setup"
        subtitle="Import targets directly from any of your integrated CRM platforms for a custom, multi-channel campaign"
      />

      {selectSource ? (
        <CrmLeads
          targetingSource={selectSource}
          urlVariable={selectSource.urlVariable}
          onBack={onBack}
          isFileError={isFileError}
          csvState={csvState}
          setCsvState={setCsvState}
        />
      ) : (
        <CrmSources setSelectSource={setSelectSource} />
      )}

      <Stepper
        selectedIndex={0}
        nextButtonComponent={
          <StepperNextButton
            isLoading={isSettingTargeting}
            disabled={isFileError}
            onClick={onNext}
          />
        }
      />
    </>
  );
}
